export default function () {
  return [
    {
      title: 'Painel de controle',
      to: {
        name: 'admin-overview',
      },
      htmlBefore: '<i class="material-icons">edit</i>',
    },
    {
      title: 'Clientes',
      htmlBefore: '<i class="material-icons">person</i>',
      to: {
        name: 'admin-customer-lista',
        params: {
          page: 1,
        },
      },
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-customer-lista',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          href: '/admin/clientes/new',
          to: {
            name: 'admin-customer-new',
          },
        },
      ],
    },
    {
      title: 'Orçamentos',
      htmlBefore: '<i class="material-icons">note_add</i>',
      to: {
        name: 'admin-quotation-list',
        params: {
          page: 1,
        },
      },
      items: [
        {
          title: 'Lista',
          to: {
            name: 'admin-quotation-list',
            params: {
              page: 1,
            },
          },
        },
        {
          title: 'Adicionar',
          href: '/admin/orcamentos/new',
          to: {
            name: 'admin-quotation-new',
          },
        },
      ],
    },
  ];
}
